var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 13.4L14.5 37.4C13.1 38.3 12.3 39.9 12.3 41.5V84C12.3 85.5 13.5 86.7 15 86.7H85C86.5 86.7 87.7 85.5 87.7 84V41.5C87.7 39.8 86.9 38.3 85.5 37.4L50 13.4Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1 23.4V45.5L50 64L19.5 44.6V23.4H79.1Z",
    fill: "#FFF4DE",
    stroke: "#FFF4DE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 55.7C44.1 55.7 39.3 50.6 40 44.5C40.7 38.4 44.3 36.1 48.9 35.6C53.5 35.1 60.1 39.7 60.1 45.6C60.1 45.6 60.1 49.8 57.8 49.8C53.5 49.8 53.9 43.8 53.9 44.8C53.9 47.1 53 49.9 50.2 49.9C47.4 49.9 46.6 48.1 46.6 45.8C46.6 43.5 48.1 41.1 50.5 41.1C52.9 41.1 53.9 43.6 53.9 44.4",
    stroke: "#FF931E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.50c1166296eb595e1f1b77f65f8bc128.svg";
export { ForwardRef as ReactComponent };